import { CustomIcons } from '@shared/icons/CustomIcons'
import { Editor, useEditorState } from '@tiptap/react'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  editor: Editor
}

export const OrderedListButton = ({ editor }: Props) => {
  const { t } = useTranslation()

  const editorState = useEditorState({
    editor,
    selector: (ctx) => {
      return {
        isOrderedList: ctx.editor.isActive('orderedList') ?? false
      }
    }
  })

  const onToggleOrderedList = () => {
    editor.chain().focus().toggleOrderedList().run()
  }

  return (
    <Tooltip title={t('editor.ordered_list')}>
      <Button
        icon={CustomIcons.OrderedList(16)}
        onClick={onToggleOrderedList}
        type={editorState.isOrderedList ? 'primary' : 'default'}
      />
    </Tooltip>
  )
}
